<template>
    <label class="switch">
        <input :checked="value" @input="handleInput" type="checkbox" />
        <div class="slider round"></div>
    </label>
</template>

<script>
export default {
    props: {
        value: {
            type: [Boolean, Number],
            default: false,
        },
    },
    methods: {
        handleInput(event) {
            const isChecked = event.target.checked;
            this.$emit("input", isChecked);
            this.$emit("update");
        },
    },
};
</script>

<style lang="scss" scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 24px;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    border: 2px solid #263238;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border: 2px solid #263238;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .slider {
    background-color: #0180ff;
}

input:focus + .slider {
    // box-shadow: 0 0 1px #0180ff;
}

input:checked + .slider:before {
    -webkit-transform: translateX(7px);
    -ms-transform: translateX(7px);
    transform: translateX(7px);
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
